export enum AwarenessMessageErrorStatuses {
  SendingError = 'SendingError',
  ReceptionError = 'ReceptionError',
  AcknowledgementError = 'AcknowledgementError',
  PollingError = 'PollingError'
}